"use client";

import { Pages } from "@shared/api";
import { Calendly as CalendlyIcon } from "@shared/assets/icons";
import { isBrowser } from "@shared/lib/is-browser";
import { RichText } from "@shared/ui/rich-text";
import { useTranslations } from "next-intl";
import { useState } from "react";
import { PopupModal } from "react-calendly";

export function Calendly() {
  const t = useTranslations(Pages.Contact);
  const [isCalendlyOpen, setIsCalendlyOpen] = useState(false);

  return (
    <>
      <RichText
        className={
          "border-t-2 border-antique-brass-500 w-full text-center text-black-pearl-950 text-lg py-8"
        }
        message={t.raw("texts.contact_02.content")}
      />

      {isBrowser() && (
        <PopupModal
          url={"https://calendly.com/beckerzuco-advocacia"}
          rootElement={document.getElementById("root")!}
          open={isCalendlyOpen}
          onModalClose={() => setIsCalendlyOpen(false)}
        />
      )}

      <div
        className={
          "flex flex-col justify-center items-start h-fit rounded overflow-clip cursor-pointer lg:px-72"
        }
        onClick={() => setIsCalendlyOpen(true)}
      >
        <CalendlyIcon className={"w-full h-fit"} />
      </div>
    </>
  );
}
